import { render, staticRenderFns } from "./programas.vue?vue&type=template&id=46069408&scoped=true&"
import script from "./programas.vue?vue&type=script&lang=js&"
export * from "./programas.vue?vue&type=script&lang=js&"
import style0 from "./programas.vue?vue&type=style&index=0&id=46069408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46069408",
  null
  
)

export default component.exports